import React, { useEffect, useState } from 'react';
import './SharkAnimation.css';

const SharkAnimation = () => {
  const [scrollDepth, setScrollDepth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const depth = Math.min(scrolled / maxScroll, 1);
      setScrollDepth(depth);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  // Only show sharks between 30-100% of scroll
  if (scrollDepth < 0.3) {
    return null;
  }

  return (
    <div className="shark-animation-container" style={{ opacity: Math.min((scrollDepth - 0.3) * 2, 1) }}>
      {/* Two sharks swimming simultaneously */}
      <div className="animated-shark shark-primary">
        <img src="/shark.gif" alt="" />
      </div>
      <div className="animated-shark shark-secondary">
        <img src="/shark.gif" alt="" />
      </div>
    </div>
  );
};

export default SharkAnimation;